module.exports = __webpack_public_path__ + "img/6bombas.4c659248.jpg";